import React from 'react';
import PropTypes from 'prop-types';
import SvgImage from '../svg-image';

function MenuLogo(props) {
	const {
		logo,
		isMaximized
	} = props;

	const showPixwelLogo = logo === '/img/pixwel.logo.png';

	return (
		<a href="/" className="flex items-center justify-center h-16">
			{showPixwelLogo
				? (
					<SvgImage
						use={`pixwel${isMaximized ? 'Lg' : 'Sm'}`}
						style={{
							width: isMaximized ? '6.75rem' : '2.5rem',
							height: isMaximized ? '3rem' : '2.5rem'
						}}
					/>
				)
				: (
					<img
						src={logo}
						alt="Pixwel"
						className="object-contain"
						style={{
							maxWidth: isMaximized ? '6.75rem' : '2.5rem',
							maxHeight: isMaximized ? '3rem' : '2.5rem'
						}}
					/>
				)}
		</a>
	);
}

MenuLogo.propTypes = {
	logo: PropTypes.string.isRequired,
	isMaximized: PropTypes.bool
};

export default MenuLogo;
